import { Observable } from 'rxjs';

// The dotted keys the app's route guard reads, so a link and the page it opens are gated by the
// same word.
export type ViewPermissionKey =
  | 'sourcingModule.sentEmails.fullList'
  | 'resourceModule.operatorApprovals'
  | 'resourceModule.operatorApprovals.modify'
  | 'resourceModule.oneOffApprovals'
  | 'resourceModule.oneOffApprovals.modify'
  | 'resourceModule.vendors.modify';

// The door to the app's session, and the DI token for it. Its implementation lives in `core/`,
// where the permissions are held; importing that from here would pull the legacy tree into the
// strict type-check this side compiles under.
export abstract class ViewPermissions {
  abstract granted(key: ViewPermissionKey): Observable<boolean>;
}
